// two bobby: shelf basket strip (22 Oct 2026). Keeps the strip on collection/search pages in step with the cart:
// after every add/change (Shopify's standard cartLinesUpdate event) it reads /cart.js once and updates the count,
// total and free-shipping gap; shows the strip when the cart has items, hides it when empty. "View cart" opens the
// drawer (falls back to /cart). Cost: one small fetch per cart change.
import { StandardEvents } from '@shopify/events';

const bar = document.querySelector('tb-shelf-bar');
if (bar) {
  const freeFrom = Number(bar.dataset.freeFrom || 0);
  const fmt = (paise) => '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  const paint = (count, total) => {
    bar.dataset.count = count;
    bar.dataset.total = total;
    const c = bar.querySelector('[data-tb-sb-count]'); if (c) c.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
    const t = bar.querySelector('[data-tb-sb-total]'); if (t) t.textContent = fmt(total);
    const s = bar.querySelector('[data-tb-sb-ship]');
    if (s && freeFrom > 0) s.textContent = total >= freeFrom ? 'Free shipping unlocked ✓' : `${fmt(freeFrom - total)} away from free shipping`;
    bar.hidden = count === 0;
  };
  const refresh = async () => {
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      paint(Number(cart.item_count || 0), Number(cart.total_price || 0));
    } catch (e) { /* keep what we have */ }
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    const p = event.promise;
    if (p && typeof p.then === 'function') p.then(() => setTimeout(refresh, 150)).catch(() => {});
    else setTimeout(refresh, 400);
  });
  bar.querySelector('[data-tb-sb-view]')?.addEventListener('click', () => {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = '/cart';
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
}
